import { isNil } from 'ramda';
import { Mailbox } from '~/graphql/types';
import { NamedEmail } from '~/util/namedEmailFormatter';
import useOffices from '../useOffices';
import useSessionHydration from '../useSessionHydration';
import useUsers from '../useUsers';

type Args = {
  senderOption: NamedEmail | null;
};

type TypeOfMailbox = Mailbox['__typename'] | undefined;

const DEFAULT_LINK = '/-/settings/account';
const OFFICE_LINK = '/-/settings/offices/';
const USER_LINK = '/-/settings/users/';
const PROFILE_LINK = '/-/settings/profile';
const useEmailConfigLink = ({ senderOption }: Args): string => {
  const [{ mailboxes, me }] = useSessionHydration();
  const offices = useOffices({});
  const users = useUsers();

  if (isNil(senderOption) || !mailboxes || !mailboxes.length)
    return DEFAULT_LINK;

  const typeOfMailbox: TypeOfMailbox = mailboxes.find(
    (mailbox: Mailbox) => mailbox.email.email === senderOption.email,
  )?.__typename;

  switch (typeOfMailbox) {
    case 'OfficeMailbox':
    case 'OfficeMailboxAlias':
      const office = offices.find(o => o.name === senderOption.name);
      return office ? `${OFFICE_LINK}${office.id}` : OFFICE_LINK;
    case 'UserMailbox':
    case 'UserMailboxAlias':
      const user = users.find(u => u.name === senderOption.name);
      if (user && user.id === me.id) return PROFILE_LINK;

      return user ? `${USER_LINK}${user.id}` : USER_LINK;
    case 'AccountMailbox':
    case 'AccountMailboxAlias':
    default:
      return DEFAULT_LINK;
  }
};

export default useEmailConfigLink;
